import React, { Fragment } from 'react';

// Icons
import ComputerIcon from '@mui/icons-material/Computer';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import KeyboardVoiceOutlinedIcon from '@mui/icons-material/KeyboardVoiceOutlined';

const Undetectability = ({
    isMobile
  }) =>  {
    return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                    Undetectability
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Learn how Interview Cheater remains completely undetectable during interviews.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Text Section */}
                <div>
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                        Coding interview platforms employ various detection methods to prevent cheating. Here's how they try to detect tools like Interview Cheater, and how we counter each measure.
                    </p>
                    <p style={{margin: '1rem 0', color: 'rgb(52,211,153)', fontWeight: 500, fontSize: '.875rem', lineHeight: '1.25rem'}}>
                        Interview Cheater has never been detected in our real interview tests by any coding platform.
                    </p>
                </div>

                {/* Text Section */}
                <div style={{margin: '2rem 0', paddingTop: '2rem', borderTop: '1px solid rgb(39,39,42)'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1.125rem', margin: 0}}>
                        Detection Methods & Our Counter-Measures
                    </h2>
                    <p style={{margin: '.75rem 0', color: 'rgb(161,161,170)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                        Below are the common methods platforms use to detect cheating, and how Interview Cheater makes each one ineffective. Each red box shows a detection method, with our counter-measure shown in green below it.
                    </p>
                </div>

                {/* Box Grid */}
                <div style={{margin: '2rem 0', display: 'grid', gridTemplateColumns: 'repeat(1,minmax(0,1fr))', gap: '1.5rem'}}>
                    {/* Box section */}
                    <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                        {/* top part */}
                        <div style={{display: 'flex', gap:'.75rem'}}>
                            <div style={{borderRadius: '50%', /*backgroundColor: 'rgba(239,68,68,.1)',*/ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '2rem', height: '2rem', color: 'rgb(248,113,113)'}}>
                                <ComputerIcon />
                            </div>
                            <div>
                                <h3 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '.875rem', margin: 0}}>
                                    Screen Sharing Detection
                                </h3>
                                <p style={{color: 'rgb(161,161,170)', lineHeight: '1.25rem', fontSize: '.875rem', marginTop: '.25rem'}}>
                                    Interviewers will ask you to share your screen on platforms like Zoom, Google Meet, Hackerrank, and Coderpad.
                                </p>
                            </div>
                        </div>
                        {/* Alert Box */}
                        <div style={{margin: '1rem 0', padding: '1rem', background: 'rgb(2,44,34,.3)', border: '1px solid rgb(6,78,59,.5)', borderRadius: '.75rem', display: 'flex', gap: '.75rem'}}>
                            {/* Icon */}
                            <div style={{/*background: 'rgb(16,185,129,.2)',*/ borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '1.25rem', height: '1.25rem', fontSize: '.5rem', color: 'rgb(110,231,183)'}}>
                                <CheckOutlinedIcon />
                            </div>
                            {/* Body section */}
                            <p style={{color: 'rgb(110,231,183)', fontSize: '.875rem', lineHeight: '1.25rem', margin: 0}}>
                                App is invisible to screen sharing software and screenshots
                            </p>
                        </div>
                    </div>

                    {/* Box section */}
                    <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                        {/* top part */}
                        <div style={{display: 'flex', gap:'.75rem'}}>
                            <div style={{borderRadius: '50%', /*backgroundColor: 'rgba(239,68,68,.1)',*/ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '2rem', height: '2rem', color: 'rgb(248,113,113)'}}>
                                <KeyboardVoiceOutlinedIcon />
                            </div>
                            <div>
                                <h3 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '.875rem', margin: 0}}>
                                    Ask for reasoning behind solutions
                                </h3>
                                <p style={{color: 'rgb(161,161,170)', lineHeight: '1.25rem', fontSize: '.875rem', marginTop: '.25rem'}}>
                                    Interviewers will ask you to reason out your solution and don't just want code.
                                </p>
                            </div>
                        </div>
                        {/* Alert Box */}
                        <div style={{margin: '1rem 0', padding: '1rem', background: 'rgb(2,44,34,.3)', border: '1px solid rgb(6,78,59,.5)', borderRadius: '.75rem', display: 'flex', gap: '.75rem'}}>
                            {/* Icon */}
                            <div style={{/*background: 'rgb(16,185,129,.2)',*/ borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '1.25rem', height: '1.25rem', fontSize: '.5rem', color: 'rgb(110,231,183)'}}>
                                <CheckOutlinedIcon />
                            </div>
                            {/* Body section */}
                            <p style={{color: 'rgb(110,231,183)', fontSize: '.875rem', lineHeight: '1.25rem', margin: 0}}>
                                Interviewers will ask you to explain your solutions. Interview Cheater comes with every line of code commented, as well as a few sentences of thoughts that will naturally lead you to a solution.
                            </p>
                        </div>
                    </div>

                    {/* Box section */}
                    <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                        {/* top part */}
                        <div style={{display: 'flex', gap:'.75rem'}}>
                            <div style={{borderRadius: '50%', /*backgroundColor: 'rgba(239,68,68,.1)',*/ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '2rem', height: '2rem', color: 'rgb(248,113,113)'}}>
                                <VisibilityOutlinedIcon />
                            </div>
                            <div>
                                <h3 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '.875rem', margin: 0}}>
                                    Webcam Monitoring
                                </h3>
                                <p style={{color: 'rgb(161,161,170)', lineHeight: '1.25rem', fontSize: '.875rem', marginTop: '.25rem'}}>
                                    Platforms track eye movements and suspicious looking away from screen
                                </p>
                            </div>
                        </div>
                        {/* Alert Box */}
                        <div style={{margin: '1rem 0', padding: '1rem', background: 'rgb(2,44,34,.3)', border: '1px solid rgb(6,78,59,.5)', borderRadius: '.75rem', display: 'flex', gap: '.75rem'}}>
                            {/* Icon */}
                            <div style={{/*background: 'rgb(16,185,129,.2)',*/ borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '1.25rem', height: '1.25rem', fontSize: '.5rem', color: 'rgb(110,231,183)'}}>
                                <CheckOutlinedIcon />
                            </div>
                            {/* Body section */}
                            <p style={{color: 'rgb(110,231,183)', fontSize: '.875rem', lineHeight: '1.25rem', margin: 0}}>
                                Use CTRL + the arrow keys to move the app with the solutions over your coding area so that your eyes never move from the code area.
                            </p>
                        </div>
                    </div>

                    {/* Box section */}
                    <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                        {/* top part */}
                        <div style={{display: 'flex', gap:'.75rem'}}>
                            <div style={{borderRadius: '50%', /*backgroundColor: 'rgba(239,68,68,.1)',*/ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '2rem', height: '2rem', color: 'rgb(248,113,113)'}}>
                                <BackupTableOutlinedIcon />
                            </div>
                            <div>
                                <h3 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '.875rem', margin: 0}}>
                                    Active tab monitoring
                                </h3>
                                <p style={{color: 'rgb(161,161,170)', lineHeight: '1.25rem', fontSize: '.875rem', marginTop: '.25rem'}}>
                                    Platforms will check if your cursor becomes inactive, or if you move from the active tab.
                                </p>
                            </div>
                        </div>
                        {/* Alert Box */}
                        <div style={{margin: '1rem 0', padding: '1rem', background: 'rgb(2,44,34,.3)', border: '1px solid rgb(6,78,59,.5)', borderRadius: '.75rem', display: 'flex', gap: '.75rem'}}>
                            {/* Icon */}
                            <div style={{/*background: 'rgb(16,185,129,.2)',*/ borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '1.25rem', height: '1.25rem', fontSize: '.5rem', color: 'rgb(110,231,183)'}}>
                                <CheckOutlinedIcon />
                            </div>
                            {/* Body section */}
                            <p style={{color: 'rgb(110,231,183)', fontSize: '.875rem', lineHeight: '1.25rem', margin: 0}}>
                                Interview Cheater is designed so that when you toggle visibility with CTRL + B, your cursor will stay focused, and your active tab will not change at all.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
  }
  
  export default Undetectability;
  